"use strict";
/*
 * Created on 26.10.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var Parser_1 = require("../../core/model/data-dictionary/Parser");

var PropDesc_1 = require("../../core/model/data-dictionary/PropDesc");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var IntegerValidator_1 = require("../../core/model/data-dictionary/validators/IntegerValidator");

var NumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/NumberGreaterThanValidator");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Entity for window types, thresholds parameters are for warnings on window product page.
 * Promotion type defines in which promotion is window type valid. Priority is used for ordering in window creation.
 *
 * @author ZSr
 */


var WindowType =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowType, _DomainObject_1$Domai);

  /**
   * @param id
   * @param name
   * @param priority number used for ordering in select box
   * @param promotionTypes promotion type lookup
   * @param defaultForPromotionTypes List of promotion types for which this window type is considered default
   * @param blocked if true window type is not visible during window creation
   * @param classification may be used to help filtering window types according to company custom needs
   * @param promoVolumeThresholdRel
   * @param promoVolumeThresholdAbs
   * @param promoVolumeThresholdEnabled
   * @param systemVolumeThresholdRel
   * @param systemVolumeThresholdAbs
   * @param systemVolumeThresholdEnabled
   */
  function WindowType(id, name, priority, promotionTypes, defaultForPromotionTypes, classification) {
    var _this;

    var blocked = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var promoVolumeThresholdRel = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var promoVolumeThresholdAbs = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    var promoVolumeThresholdEnabled = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
    var systemVolumeThresholdRel = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var systemVolumeThresholdAbs = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
    var systemVolumeThresholdEnabled = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : true;

    _classCallCheck(this, WindowType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowType).call(this));
    _this.id = id;
    _this.name = name;
    _this.priority = priority;
    _this.promotionTypes = promotionTypes;
    _this.defaultForPromotionTypes = defaultForPromotionTypes;
    _this.classification = classification;
    _this.blocked = blocked;
    _this.promoVolumeThresholdRel = promoVolumeThresholdRel;
    _this.promoVolumeThresholdAbs = promoVolumeThresholdAbs;
    _this.promoVolumeThresholdEnabled = promoVolumeThresholdEnabled;
    _this.systemVolumeThresholdRel = systemVolumeThresholdRel;
    _this.systemVolumeThresholdAbs = systemVolumeThresholdAbs;
    _this.systemVolumeThresholdEnabled = systemVolumeThresholdEnabled;
    return _this;
  }

  return WindowType;
}(DomainObject_1.DomainObject);

exports.WindowType = WindowType;
WindowType.CODEBOOK_NAME = 'window.types';

WindowType.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowType.name);
  return {
    id: builder.id('id'),
    name: builder.trimStr('name', new StringLengthValidator_1.StringLengthValidator(3, 255)),
    priority: builder.num('priority'),
    promotionTypes: builder.listOf(builder.lookup('promotionTypes', CodebookLookupSequence_1.CodebookLookupSequence.PromotionTypes)),
    defaultForPromotionTypes: builder.listOf(builder.lookup('defaultForPromotionTypes', CodebookLookupSequence_1.CodebookLookupSequence.PromotionTypes)),
    blocked: builder.bool('blocked'),
    classification: builder.opt(new PropDesc_1.PropDesc(new Parser_1.StringMapParser(), {
      nameKey: WindowType.name + '_classification'
    })),
    promoVolumeThresholdRel: builder.num('promoVolumeThresholdRel', new IntegerValidator_1.IntegerValidator(), new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true)),
    promoVolumeThresholdAbs: builder.num('promoVolumeThresholdAbs', new IntegerValidator_1.IntegerValidator(), new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true)),
    promoVolumeThresholdEnabled: builder.bool('promoVolumeThresholdEnabled'),
    systemVolumeThresholdRel: builder.num('systemVolumeThresholdRel', new IntegerValidator_1.IntegerValidator(), new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true)),
    systemVolumeThresholdAbs: builder.num('systemVolumeThresholdAbs', new IntegerValidator_1.IntegerValidator(), new NumberGreaterThanValidator_1.NumberGreaterThanValidator(0, true)),
    systemVolumeThresholdEnabled: builder.bool('systemVolumeThresholdEnabled')
  };
}();